import React from "react"
import { useSelector } from "react-redux";
import { StyledModalBody } from "../../../../../components/Modals";
import { ButtonBodyVariant } from "../../../../../components/ui/ButtonVariant";
import { useTranslation } from "react-i18next";
import { closeActiveModal, openModal } from "../../../../../helper/modals";
import { Flex } from "../../../../../components/ui/Flex";
import { Palette } from "../../../../../components/utils";
import { IoMdCheckmark } from "react-icons/io";
import { closeAndClearPaymentData, DescriptionText, IconBackground, ModalButtonsContainer, PaymentModal, TitleText } from "../../../PaymentComponents";

const AccountSuccessSetupModal = () => {
  const { t } = useTranslation();
  const modal = useSelector((state) => state.headerModal.modal);
  const addPayment = useSelector((state) => state.addPayment);

  return (
    <PaymentModal
      show={modal === 'AccountSuccessSetupModal'}
      onClose={closeActiveModal}
      closeOnBackdrop={false}
      width={'460px'}
      padding={"2.25rem 1.5rem 3rem 1.5rem"}
    >
      <StyledModalBody>
        <Flex direction="column" alignItems="center" gap="1.5rem">
          <IconBackground background={Palette.GREEN_500}>
            <IoMdCheckmark size={32} color={Palette.WHITE} style={{ position: "absolute", right: "12px", top: "11px" }} />
          </IconBackground>
          <Flex direction="column" alignItems="center" gap="1rem">

            <TitleText lg>{t('Success')}</TitleText>
            <DescriptionText>
              Direct Deposit has been successfully set up for {`${addPayment.userId.label}`}.
            </DescriptionText>

          </Flex>
          <ModalButtonsContainer gapY="8px" column>
            <ButtonBodyVariant onClick={() => { openModal('SelectPaymentTypeModal') }} cssOverride={"width: 100%;"}>{t('Create Payment')}</ButtonBodyVariant>
            <ButtonBodyVariant variant="secondary" onClick={closeAndClearPaymentData} cssOverride={"width: 100%;"}>{t('Exit')}</ButtonBodyVariant>
          </ModalButtonsContainer>
        </Flex>
      </StyledModalBody>
    </PaymentModal>
  )
}

export default AccountSuccessSetupModal